import type { FunctionComponent, HTMLAttributes } from 'react';

import styles from './Text.module.css';

interface TextProps extends HTMLAttributes<HTMLDivElement> {}

export const Text: FunctionComponent<TextProps> = ({ className = '', children, ...rest }) => {
  return (
    <div className={`${styles.text} ${className}`} {...rest}>
      {children}
    </div>
  );
};
